import React from "react";

const FaqArea = () => {
  return (
    <section className="faq-area-3 space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7">
            <div className="title-area text-center mb-60">
              <span className="sub-title">
                <img src="assets/img/icon/title_left.svg" alt="Ícone FAQ Rocvel" />
                Dúvidas Frequentes
              </span>
              <h2 className="sec-title style2">
                Transformando a gestão de talentos em resultados reais
              </h2>
            </div>
          </div>
          <div className="col-xl-10">
            <div className="accordion-area accordion" id="faqAccordion">
              
              {/* FAQ 1 */}
              <div className="accordion-card style3 active">
                <div className="accordion-header" id="heading-1">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="true" aria-controls="collapse-1">
                    Quais são os principais serviços de RH oferecidos pelo Grupo Rocvel?
                  </button>
                </div>
                <div id="collapse-1" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">Oferecemos um ecossistema completo que inclui Recrutamento e Seleção Estratégica, Hunting de Alta Liderança, Estruturação de Equipes, RPO (Terceirização de Recrutamento) e Consultoria em Gestão de Talentos.</p>
                  </div>
                </div>
              </div>

              {/* FAQ 2 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-2">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="false" aria-controls="collapse-2">
                    Qual é o tempo médio para a entrega de candidatos qualificados?
                  </button>
                </div>
                <div id="collapse-2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">Graças ao nosso banco de talentos vivo, conseguimos apresentar os primeiros perfis qualificados em poucos dias úteis, garantindo agilidade máxima para sua operação.</p>
                  </div>
                </div>
              </div>

              {/* FAQ 3 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-3">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-3" aria-expanded="false" aria-controls="collapse-3">
                    O que é o serviço de Hunting e para quem é indicado?
                  </button>
                </div>
                <div id="collapse-3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">É uma busca ativa e confidencial de talentos estratégicos, indicada para posições técnicas de alta complexidade e cargos de alta liderança (C-Level, Diretores e Gerentes).</p>
                  </div>
                </div>
              </div>

              {/* FAQ 4 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-4">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-4" aria-expanded="false" aria-controls="collapse-4">
                    Como funciona o modelo de RPO (Recruitment Process Outsourcing)?
                  </button>
                </div>
                <div id="collapse-4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">No RPO, assumimos a terceirização parcial ou integral do seu recrutamento, acoplando um braço de elite à sua operação para gerar economia e previsibilidade.</p>
                  </div>
                </div>
              </div>

              {/* FAQ 5 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-5">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-5" aria-expanded="false" aria-controls="collapse-5">
                    Como o Grupo Rocvel garante a redução do turnover?
                  </button>
                </div>
                <div id="collapse-5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">Utilizamos mapeamento de perfil e análise comportamental, garantindo candidatos com forte aderência cultural aos valores da sua empresa, resultando em contratações assertivas.</p>
                  </div>
                </div>
              </div>

              {/* FAQ 6 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-6">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-6" aria-expanded="false" aria-controls="collapse-6">
                    Têm capacidade para demandas de recrutamento em grande escala?
                  </button>
                </div>
                <div id="collapse-6" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">Sim, possuímos estrutura técnica flexível para suportar picos sazonais, montagem célere de times operacionais e expansões aceleradas em todo o território nacional.</p>
                  </div>
                </div>
              </div>

              {/* FAQ 7 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-7">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-7" aria-expanded="false" aria-controls="collapse-7">
                    As soluções se aplicam a empresas de pequeno/médio porte?
                  </button>
                </div>
                <div id="collapse-7" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">Perfeitamente. Nossa flexibilidade estrutural permite desenhar projetos sob medida tanto para empresas que buscam crescimento estruturado quanto para grandes corporações.</p>
                  </div>
                </div>
              </div>

              {/* FAQ 8 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-8">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-8" aria-expanded="false" aria-controls="collapse-8">
                    Os processos estão em conformidade com a LGPD?
                  </button>
                </div>
                <div id="collapse-8" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">Absolutamente. Todas as nossas etapas de captação e tratamento de dados são conduzidas sob os mais rigorosos padrões e diretrizes da Lei Geral de Proteção de Dados.</p>
                  </div>
                </div>
              </div>

              {/* FAQ 9 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-9">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-9" aria-expanded="false" aria-controls="collapse-9">
                    Como é feito o acompanhamento durante o processo seletivo?
                  </button>
                </div>
                <div id="collapse-9" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">Sua empresa terá o acompanhamento de especialistas dedicados que fornecem alinhamentos frequentes, relatórios de performance e transparência total sobre cada vaga.</p>
                  </div>
                </div>
              </div>

              {/* FAQ 10 */}
              <div className="accordion-card style3">
                <div className="accordion-header" id="heading-10">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-10" aria-expanded="false" aria-controls="collapse-10">
                    Como posso contratar o Grupo Rocvel ou solicitar um orçamento?
                  </button>
                </div>
                <div id="collapse-10" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p className="faq-text">Basta acessar nossa página de contato ou clicar nos botões de ação para agendar um diagnóstico gratuito. Analisaremos suas dores e desenharemos uma proposta personalizada.</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqArea;